(() => {
  const angular = window.angular;

  angular.module('app').config(Router);

  Router.$inject = ['$stateProvider'];

  function Router($stateProvider) {
    $stateProvider.state('member.customer.show.project.cargoContainerLog', {
      url: '/cargo-container-log',
      template: `<new-front-container path="'cargo-container-log'"></new-front-container>`,
      authenticated: true,
      ncyBreadcrumb: {
        label: '{{"entities.tool.__tools.CargoContainerLog" | translate}}',
      },
    });
  }
})();
